import { Component, Input, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { AttachmentType } from './model/attachmentType';
import { WorkExperience } from './model/WorkExperience';

@Component({
    selector: 'app-technician-application',
    templateUrl: './technicianApplication.component.html',
    styleUrls: ['./application.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class TechnicianApplicationComponent implements OnInit{
    @Input() application: any;
    attachmentType = AttachmentType;
    downloading = false;
    downloadClickCount = 0;
    workExperiences!: WorkExperience[];

    constructor() {}

    ngOnInit() {
        this.application.workExperiences = this.application.workExperiences.map((experience: any) => new WorkExperience(experience));
        this.workExperiences = this.application.workExperiences;
    }

    nth(i: number) {
        return i === 0 ? 'first' : (i === 1 ? 'second' : 'third');
      }

}

